import { useTranslation } from 'react-i18next';
import { useRootSelector } from '../../../../../store/hooks';

import { selectSiteHeader } from '../../../../../store/features/siteHeader';

import PaymentProvider from '../../../shared/PaymentProvider';
import Layout from '../../../shared/layouts/Layout';
import PageLayout from '../../../shared/layouts/PageLayout';
import { MetaTags } from '../../../../hub/shared/MetaTags';
import OrderNotFoundMessage from '../components/OrderNotFoundMessage';
import BookingClosedMessage from '../components/BookingClosedMessage';

export default function OrderNotFound() {
  const { t } = useTranslation();
  const siteHeader = useRootSelector(selectSiteHeader);
  const booking = Boolean(siteHeader?.data?.booking);
  const title = siteHeader?.meta?.title || siteHeader?.data?.title || '';
  const pageTitle = title
    ? `${t('site.pricing.order-not-found')} | ${title}`
    : t('site.pricing.order-not-found');

  return (
    <PaymentProvider>
      <Layout disableUpperFooter>
        <MetaTags title={pageTitle} />
        <PageLayout variant="full">
          {booking ? <OrderNotFoundMessage /> : <BookingClosedMessage />}
        </PageLayout>
      </Layout>
    </PaymentProvider>
  );
}
